export default "__VITE_PUBLIC_ASSET__f6d8d8fc__"